
export class CauHinhBuoc {
    Id:number = 0;
    IdQuyTrinh: number = 0;
    IdBuoc: number = 0;
    IdKetQua: number = 0;
    ThaoTac: string ="";
    IdBuocSau: number = 0;
    EditAble: boolean = false;
    Saving: boolean = false;
    ChuTri:boolean=false;
    Chon:boolean=false;
    IdNhom:number=0;
    LoaiNhom:number=0;
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/quy-trinh-xu-ly/cau-hinh-buoc.ts